import { useEffect } from 'react';

export const useKeyboardNavigation = ({ arrowLeftRef, arrowRightRef }) => {
  const shouldDisableArrowNavigation = () =>
    ['input', 'textarea', 'iframe'].includes(
      document.activeElement.tagName.toLocaleLowerCase(),
    );

  useEffect(() => {
    const navigate = e => {
      if (shouldDisableArrowNavigation()) return;

      if (e.key === 'ArrowLeft') {
        // we need to update eslit to get rid of the error here: https://github.com/eslint/eslint/issues/12822
        // eslint-disable-next-line no-unused-expressions
        arrowLeftRef.current?.click();
      }
      if (e.key === 'ArrowRight') {
        // eslint-disable-next-line no-unused-expressions
        arrowRightRef.current?.click();
      }
    };

    document.addEventListener('keydown', navigate);

    return () => {
      document.removeEventListener('keydown', navigate);
    };
  }, [arrowLeftRef, arrowRightRef]);
};
